import styled from 'styled-components';

export const GridContainer = styled.div`
  width: 100%;
  
  iframe {
    height: 870px;
  
    @media(min-width: 848px) {
      height: 750px;
    }
    
    @media(min-width: 1080px) {
      height: 630px;
    }
  }
`;
